import {
  SET_NOTIFICATION,
  REMOVE_NOTIFICATION,
  SET_OTP_NOTIFICATION,
  REMOVE_OTP_NOTIFICATION,
} from './types';

export default (state, action) => {
  switch (action.type) {
    case SET_NOTIFICATION:
      return action.payload;
    case REMOVE_NOTIFICATION:
      return null;
    case SET_OTP_NOTIFICATION:
      return action.payload;
    case REMOVE_OTP_NOTIFICATION:
      return null;

    default:
      return state;
  }
};
